export default __webpack_public_path__ + "static/media/3-mobile.be6b19d8.png";